type PdfPasswordInfo = {
  passwordRequired: boolean;
  sourceFile?: File;
};

const pdfPasswordInfos = new WeakMap<File, PdfPasswordInfo>();

export const getProtectedPdfSource = (file: File) =>
  pdfPasswordInfos.get(file)?.sourceFile;

export const getPdfPasswordStatus = (file: File) =>
  pdfPasswordInfos.get(file)?.passwordRequired;

export const markPdfPasswordChecked = (
  file: File,
  passwordRequired: boolean
) => {
  if (!pdfPasswordInfos.has(file)) {
    pdfPasswordInfos.set(file, { passwordRequired });
  }
};

export const registerProtectedPdfSource = (
  unlockedFile: File,
  sourceFile: File
) => {
  pdfPasswordInfos.set(unlockedFile, {
    passwordRequired: true,
    sourceFile: getProtectedPdfSource(sourceFile) ?? sourceFile,
  });
};

export const copyPdfPasswordInfo = (fromFile: File, toFile: File) => {
  const info = pdfPasswordInfos.get(fromFile);

  if (info && !pdfPasswordInfos.has(toFile)) {
    pdfPasswordInfos.set(toFile, info);
  }
};
